// Missing business dates must remain blank, never fall back to generation time.
export function formatCertificateDate(version) {
  const value = Object.prototype.hasOwnProperty.call(version, 'certificate_issued_at')
    ? version.certificate_issued_at : version.issued_at;
  if (!value) return '';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleString('ja-JP', {timeZone: 'Asia/Tokyo'});
}
